module.exports = __webpack_public_path__ + "media/images/prediction/special/aokei/img_thumb-02a53bf231ef14cad1e2e076809b9eb4.jpg";